import ReactMarkdown from 'react-markdown';
import { Helmet } from 'react-helmet-async';

import { Column } from '@simplywallst/ui-core';

import { useContentfulImage } from '@/hooks/useContentfulImage';
import DeferRenderUntilIntersecting from '@/components/DeferRenderUntilIntersecting';

import {
  WorkWithUsContainerRow,
  WorkWithUsContentRow,
  StyledReactMarkdown,
  WorkWithUsHeader,
} from './styled';
import { OneColumnExpanded } from '../../styled';

interface Image {
  title?: string;
  description?: string;
  url?: string;
}

interface Props {
  title?: string;
  subtitle?: string;
  markdownContent: string[];
  gallery?: Image[];
}

export const WorkWithUs = ({ title, gallery, markdownContent }: Props) => {
  const workWithUsImage = useContentfulImage({
    url: gallery && gallery[0] && gallery[0]?.url,
    title: gallery && gallery[0] ? gallery[0].title : '',
    format: 'avif',
  });
  const workWithUsImageFallback = useContentfulImage({
    url: gallery && gallery[0] && gallery[0]?.url,
    title: gallery && gallery[0] ? gallery[0].title : '',
  });

  return (
    <>
      <Helmet>
        <link rel="prefetch" href={workWithUsImage?.src} />
        <link rel="prefetch" href={workWithUsImageFallback?.src} />
      </Helmet>
      <WorkWithUsContainerRow justifyContent="center" bgColor="#EAF3FF">
        <OneColumnExpanded>
          <WorkWithUsContentRow>
            <Column colMd={6} data-cy-id="workWithUs">
              <WorkWithUsHeader>{title}</WorkWithUsHeader>
              <StyledReactMarkdown>
                <ReactMarkdown source={markdownContent[0]} />
              </StyledReactMarkdown>
            </Column>
            <Column
              colMd={6}
              displayFlex
              alignItemSm="flex-start"
              justifyContent="flex-end"
            >
              {workWithUsImage && workWithUsImageFallback && (
                <DeferRenderUntilIntersecting>
                  {() => (
                    <picture>
                      <source srcSet={workWithUsImage.src} type="image/avif" />
                      <img
                        src={workWithUsImageFallback.src}
                        alt={workWithUsImageFallback.alt}
                        height="240"
                      />
                    </picture>
                  )}
                </DeferRenderUntilIntersecting>
              )}
            </Column>
          </WorkWithUsContentRow>
        </OneColumnExpanded>
      </WorkWithUsContainerRow>
    </>
  );
};
